import React from "react";
import { Wrapper, StyledLayout, Body, StickyFooter } from "./layout";
import { Black } from "../theme/colors";
import LabelBottomNavigation from "./BottomNavigation";
import { auth } from "../../services/firebase.config";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

function MinimalLayout({ children, $background, hideFooter = false }) {
  const currentUser = auth.currentUser;

  if (!isMobile) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
          color: "white",
          fontFamily: "Satoshi-Variable",
          textAlign: "center",
          padding: "20px",
        }}
      >
        This app is currently only available on mobile devices. Please open it
        on your phone.
      </div>
    );
  }

  return (
    <Wrapper $background={$background || Black}>
      <StyledLayout>
        <Body $noNavbar $noFooter={hideFooter}>
          {children}
        </Body>
      </StyledLayout>
      {currentUser && !currentUser.isAnonymous && !hideFooter && (
        <StickyFooter sx={{ position: "fixed" }} elevation={3}>
          <LabelBottomNavigation />
        </StickyFooter>
      )}
    </Wrapper>
  );
}

export default MinimalLayout;
